/**
 * Bootstrap-Komponente: probiert beim ersten Mount /auth/refresh
 * + /auth/me um eine eventuell noch gültige Session wiederherzustellen.
 * Zeigt einen Mini-Loader bis das geklärt ist.
 */
import { useEffect, useState } from "react";
import { authApi } from "@/api/endpoints";
import { useAuthStore } from "./store";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);
  const setSession = useAuthStore((s) => s.setSession);

  useEffect(() => {
    (async () => {
      try {
        // Wenn ein Refresh-Cookie vorliegt: Token ziehen + me() laden
        const refreshed = await authApi.refresh();
        // /me wird durch den Request-Interceptor automatisch authentifiziert,
        // sobald der neue Token im Store steht.
        useAuthStore.setState({ accessToken: refreshed.access_token });
        const me = await authApi.me();
        setSession(refreshed.access_token, me);
      } catch {
        // kein Login vorhanden — egal
      } finally {
        setReady(true);
      }
    })();
  }, [setSession]);

  if (!ready) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        Lade Session …
      </div>
    );
  }
  return <>{children}</>;
}
